import { cn } from '@/app/lib/utils';
import { getTagButtonClasses } from './utils';

interface TagButtonProps {
  label: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onClick: () => void;
  className?: string;
  classNames?: {
    button?: string;
    selectedButton?: string;
    disabledButton?: string;
  };
}

export function TagButton({ label, isSelected, isDisabled = false, onClick, className, classNames }: TagButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        getTagButtonClasses({ isSelected, isDisabled }),
        'min-w-36.75 max-w-70',
        className,
        classNames?.button,
        isSelected && classNames?.selectedButton,
        isDisabled && classNames?.disabledButton,
      )}
      disabled={isDisabled}
      aria-pressed={isSelected}
    >
      <span className="truncate">{label}</span>
    </button>
  );
}
